module.exports = __webpack_public_path__ + "static/media/Disclaimer_DIY.15f30972.pdf";